module.exports = __webpack_public_path__ + "img/precious01.bb4c19bd.jpg";